function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgTrash = function SvgTrash(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Trash' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("polygon", {
    points: "14.501 37.0454 13.501 15.0454 15.499 14.9544 16.499 36.9544"
  }), React.createElement("polygon", {
    points: "25.499 37.0454 23.501 36.9544 24.501 14.9544 26.499 15.0454"
  }), React.createElement("path", {
    d: "M13.3877,6 L26.6127,6 L25.9627,4.051 C25.5537,2.824 24.4097,2 23.1167,2 L16.8827,2 C15.5897,2 14.4467,2.824 14.0367,4.051 L13.3877,6 Z M6.9507,46 L33.0487,46 L34.9487,8 L5.0517,8 L6.9507,46 Z M34.9507,48 L5.0487,48 L3.0487,8 L-0.0003,8 L-0.0003,6 L11.2797,6 L12.1397,3.419 C12.8217,1.374 14.7277,0 16.8827,0 L23.1167,0 C25.2727,0 27.1787,1.374 27.8607,3.419 L28.7207,6 L39.9997,6 L39.9997,8 L36.9507,8 L34.9507,48 Z"
  }));
};

SvgTrash = pure(SvgTrash);
SvgTrash.displayName = 'SvgTrash';
export default SvgTrash;